export const BRAND_INFO_ROW_STALE_TIME = 1000 * 60 * 5; // 5 minutes

export const MAX_NUM_OF_PRODUCTS_TO_DISPLAY_MOBILE = 8;
export const MAX_NUM_OF_PRODUCTS_TO_DISPLAY = 10;
export const MAX_NUM_OF_PRODUCTS_TO_DISPLAY_WHEN_EXPANDED = 50;
